import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ae39736a")

_pushScopeId("data-v-ae39736a")
const _hoisted_1 = { class: "admin-contract-user-create" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, "新規ユーザー登録")
], -1)
const _hoisted_3 = { class: "contract" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "title" }, "会社名：", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "title" }, "部署名（任意）：", -1)
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "form" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "title" }, "ユーザーID（メールアドレス）：", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "title" }, "氏名（任意）：", -1)
const _hoisted_11 = { class: "commands" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "キャンセル", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "ユーザー追加", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.contract.companyName), 1),
      _hoisted_6,
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.contract.optionName), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createVNode("input", {
        class: "value",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email = $event)),
        maxlength: _ctx.consts.maxEMailLength
      }, null, 8, ["maxlength"]), [
        [_vModelText, _ctx.user.email]
      ]),
      _createVNode(_component_ErrorMessage, {
        class: "value",
        messages: _ctx.errorMessages.email
      }, null, 8, ["messages"]),
      _hoisted_10,
      _withDirectives(_createVNode("input", {
        class: "value",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.name = $event)),
        maxlength: _ctx.consts.maxUserNameLength
      }, null, 8, ["maxlength"]), [
        [_vModelText, _ctx.user.name]
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
      }, [
        _hoisted_12
      ]),
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
      }, [
        _hoisted_13
      ])
    ])
  ]))
})